import api from '@/utils/api'

export default {
    getBetweenDates(query, isDesired) {
        return api.get(`assignments/task-assignments?startDate=${query.startDate}&endDate=${query.endDate}` + (isDesired ? '&desired=true' : ''))
    }
}
